import styled from '@emotion/styled';
import { TableCell, TableContainer } from '@mui/material';

export const FooterLabelCell = styled(TableCell)`
  border-top: none;
  border-bottom: none;
  font-size: 14px;
`;

export const StyledTableContainer = styled(TableContainer)`
  margin-top: 2rem;
  border-radius: 8px;
  background-color: transparent;
  border: 1px solid ${({ theme }) => theme.palette?.grey?.[300]};
`;

export const StyledWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 2rem;
`;

export const StyledGroup = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

export const StyledInfo = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 1rem;
`;

export const StyledDivider = styled.div`
  width: 5rem;
`;
